<div [hidden]="!usersMap.size" class="controls-panel">
    <div class="title">
        <h3>Users <small *ngIf="!visibleUsers.length">(Top 5)</small> <i [style]="{opacity: loading ? 1 : 0}"
                class="fas fa-sync fa-spin text-muted title-spinner"></i></h3>
    </div>
    <div class="controls">
        <div class="users-config">
            <button class="btn btn-sm btn-default cp" type="button" (click)="onClickConfig()">All users <i class="icon-filter text-primary mx-0_5"></i></button>
        </div>
        <div>
            <a [tooltip]="'Include all the tests that were submitted'" [tooltipPlacement]="'top'" style="padding-left: 0" class="btn btn-sm"
                [ngClass]="{'btn-link': chartItems === 'submitted', 'btn-default': chartItems !== 'submitted'}" (click)="setChartItems('submitted')"
                type="button">Submitted</a>
            <a [tooltip]="'Only include the tests that were billed'" [tooltipPlacement]="'top'" class="btn btn-sm"
                [ngClass]="{'btn-link': chartItems === 'billed', 'btn-default': chartItems !== 'billed'}" (click)="setChartItems('billed')"
                type="button">Billed</a>
        </div>
    </div>
</div>
<div [hidden]="!usersMap.size" #chartContainer>
    <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="setChart($event)"></highcharts-chart>
</div>


<ng-template #usersModalTpl let-dialogRef="dialogRef">
    <div class="modal-header mb-10">
        <div class="modal-title">
            <h3 class="d-inline-block">Users</h3>
            <button type="button" class="btn-close" (click)="dialogRef.close(true)">
                <span class="icon-close"></span>
            </button>
        </div>
    </div>
    <div class="modal-body users-modal">
        <table class="table">
            <tbody>
                <tr *ngFor="let user of chartData.users" (click)="onClickUser(user)">
                    <td class="checkbox-column">
                        <div class="input-check">
                            <input type="checkbox" class="form-check-input" [ngModel]="user.visible" [disabled]="!user.visible && !user.sortValue" />
                            <label></label>
                        </div>
                    </td>
                    <td><strong>{{user.userTitle}}</strong> ({{ user.sortValue }} tests)</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
